import { render, staticRenderFns } from "./orgcampus.vue?vue&type=template&id=cf6f8b4a"
import script from "./orgcampus.vue?vue&type=script&lang=js"
export * from "./orgcampus.vue?vue&type=script&lang=js"
import style0 from "./orgcampus.vue?vue&type=style&index=0&id=cf6f8b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports